import React, {useEffect, useState} from "react";
import {
    Box,
    Popover,
    PopoverBody,
    PopoverContent,
    PopoverTrigger,
    IconButton, Text,
} from "@chakra-ui/react";

import {useDispatch} from "react-redux";

import IconWithTooltip from "../../components/Icon/IconWithTooltip";
import {OrderController} from "../../controllers/OrderController";
import {useAppSelector} from "../../redux/Store";
import {FiEye} from "react-icons/all";


const OrderPaperPopover: React.FC = () => {
    const dispatch = useDispatch();
    const [confirmNumber, setConfirmNumber] = useState<string>("");

    const [isLoading, setIsLoading] = useState<boolean>(false); // Добавим состояние загрузки
    const order = useAppSelector(store => store?.OrderReducer?.order)
    const paperOrder = useAppSelector(store => store?.OrderReducer?.paperOrder)

    const orderController = new OrderController(dispatch)

    const onOpen = () => {
        setIsLoading(true)
        if (confirmNumber) {
            orderController.getPaperOrder(confirmNumber).then(res => {
                setIsLoading(false)
            })
        }
    };

    useEffect(() => {
        if (order) {
            setConfirmNumber(order?.confirmNumber || "");
        }
    }, [order]);

    return (
        <Popover closeOnBlur={true} onOpen={onOpen} placement='bottom-end'>
            {({isOpen, onClose}) => (
                <>
                    <PopoverTrigger>
                        <IconButton bg={"transparent"} _hover={{bg: "transparent"}} _active={{bg: "transparent"}}
                                    aria-label="Show order paper" size={"xs"}>
                            <IconWithTooltip icon={FiEye} onClick={onOpen} tooltipMessage={'Show order paper'}/>
                        </IconButton>
                    </PopoverTrigger>
                    <PopoverContent
                        style={{
                            padding: 8,
                            maxHeight: "calc(67vh - 20px)",
                            overflowY: "auto",
                            minWidth: "50%",
                        }}
                    >
                        <PopoverBody p={0} fontSize={14}>
                            {isLoading ? (
                                <Text textAlign="center" fontSize={16} p={4}>
                                    Loading...
                                </Text>
                            ) : confirmNumber ? (
                                <Box>
                                    <Text fontSize="14" fontWeight="bold">Business Name:</Text>
                                    <Text>{paperOrder?.businessName || "N/A"}</Text>

                                    <Text fontSize="14" fontWeight="bold" mt={1}>Contact Name:</Text>
                                    <Text>{paperOrder?.contactName || "N/A"}</Text>

                                    <Text fontSize="14" fontWeight="bold" mt={1}>Address:</Text>
                                    <Text>{`${paperOrder?.address1 || "N/A"} ${paperOrder?.address2 || ""}`}</Text>

                                    <Text fontSize="14" fontWeight="bold" mt={1}>City, State, ZIP:</Text>
                                    <Text>{`${paperOrder?.city || "N/A"}, ${paperOrder?.state || "N/A"} ${paperOrder?.zip || "N/A"}`}</Text>

                                    <Text fontSize="14" fontWeight="bold" mt={1}>Email Address:</Text>
                                    <Text>{paperOrder?.emailAddress || "N/A"}</Text>

                                    <Text fontSize="14" fontWeight="bold" mt={1}>Phone Number:</Text>
                                    <Text>{paperOrder?.phoneNumber || "N/A"}</Text>

                                    <Text fontSize="14" fontWeight="bold" mt={1}>Order Date:</Text>
                                    <Text>{paperOrder?.orderDate ? new Date(paperOrder.orderDate).toLocaleString() : "N/A"}</Text>

                                    <Text fontSize="14" fontWeight="bold" mt={1}>Quantity:</Text>
                                    <Text>{paperOrder?.quantity || "N/A"}</Text>

                                    <Text fontSize="14" fontWeight="bold" mt={1}>Status:</Text>
                                    <Text>{paperOrder?.status || "N/A"}</Text>

                                    {paperOrder?.statusHistory && paperOrder?.statusHistory?.paperOrderStatuses?.length > 0 && (
                                        <Box mt={4}>
                                            <Text fontSize="14" fontWeight="bold">Status History:</Text>
                                            {paperOrder.statusHistory.paperOrderStatuses.map((status, index) => (
                                                <Box key={index} mt={2} p={2} border="1px solid #e2e2e2"
                                                     borderRadius="md">
                                                    <Text>Status: {status.status}</Text>
                                                    <Text>Date: {new Date(status.statusDate).toLocaleString()}</Text>
                                                    <Text>Updated By: {status.username}</Text>
                                                    {status.showComment && status.comment && (
                                                        <Text>Comment: {status.comment}</Text>
                                                    )}
                                                </Box>
                                            ))}
                                        </Box>
                                    )}
                                </Box>
                            ) : (
                                <Text textAlign="center" fontSize={16} p={4}>
                                    No data available.
                                </Text>
                            )}
                        </PopoverBody>
                    </PopoverContent>
                </>
            )}
        </Popover>
    );
};

export default OrderPaperPopover;
